import { SvgIcon } from '@mui/material';

export default function DialogWarning(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 29.51 29.36" style={{ ...props.style, width: `24px`, height: `24px` }}>
      <path d="M14.76,.05C6.68,.05,.13,6.6,.13,14.68s6.55,14.62,14.62,14.62,14.62-6.55,14.62-14.62C29.38,6.6,22.84,.05,14.76,.05h0Zm1.21,7.71l-.22,8.09c.02,.56-.42,1.02-.97,1.04h-.02c-.56,0-1-.46-.99-1.02v-.02l-.22-8.09c-.01-.67,.52-1.22,1.18-1.24h.02c.67,0,1.21,.54,1.21,1.21v.02Zm-1.21,13.81c-.71-.03-1.27-.63-1.25-1.34,.03-.71,.63-1.27,1.34-1.25,.7,.03,1.25,.6,1.25,1.3,0,.72-.6,1.3-1.32,1.29h-.02Z" />
    </SvgIcon>
  );
}
